import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import instance from "../../services/services";
import { SEARCH_URL } from "../../utils/urls";
import EventPopup from "../../components/Popup/EventPopup";
import ProductSection from '../../components/Product/ProductSection';
import PaginationSection from '../../components/Product/Pagination';
import DefaultSelect from '../More/DefaultSelect';
import event_poster from '../../assets/img/event_poster.png';
import event_poster2 from '../../assets/img/event_poster2.png';
import { useLanguage } from '../../hooks/useLanguage';

function SearchPage() {
    const { t } = useLanguage();
    const [searchParams] = useSearchParams();
    const keyword = searchParams.get('keyword');
    const [activeTab, setActiveTab] = useState('product');
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [currentSort, setCurrentSort] = useState('regist_date'); // 정렬 상태 추가
    const itemsPerPage = 30;
    const [searchType, setSearchType] = useState('goods');
    const [eventPop, setEventPop] = useState(false);
    
    const handleViewMore = () => {
        setEventPop(true);
    };

    // 검색 결과 가져오는 함수
    const fetchSearchResults = async (page, type, sortValue) => {
        try {
            setLoading(true);
            const response = await instance.post(SEARCH_URL, {
                searchText: keyword,
                searchType: type,
                searchSort: sortValue,
                offset: page
            });
            
            setProducts(response.data.data.data || []);
            setTotalCount(parseInt(response.data.data.cntRow || 0));
            setLoading(false);
        } catch (error) {
            console.error("검색 결과 가져오기 실패", error);
            setLoading(false);
        }
    };

    // 초기 로드 시에만 실행
    useEffect(() => {
        if (keyword) {
            fetchSearchResults(1, 'goods', currentSort);
            setCurrentPage(1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keyword]); // keyword가 변경될 때만 실행

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchSearchResults(page, searchType, currentSort);
        window.scrollTo(0, 0);
    };

    const handleArrowClick = (page) => {
        handlePageChange(page);
    };

    // 정렬 변경 핸들러 추가
    const handleSortChange = (value) => {
        setCurrentSort(value);
        setCurrentPage(1);
        fetchSearchResults(1, searchType, value);
    };

    const handleTabClick = async (tab) => {
        setActiveTab(tab);
        setLoading(true);
        setCurrentPage(1);
        
        const newSearchType = tab === 'event' ? 'event' : 'goods';
        setSearchType(newSearchType);
        
        await fetchSearchResults(1, newSearchType, currentSort);
    };

    const BeforeContent = () => (
        <div className="auth_find" style={{marginBottom:"-16px"}}>
            <div className="product_total">
                {t('product_total_count', {count: totalCount})}
            </div>
            <DefaultSelect 
                defaultValue={currentSort}
                onChange={handleSortChange}
            />
        </div>
    );

    // afterContent 컴포넌트에서 PaginationSection 사용
    const AfterContent = () => (
        <div className="pagination_wrap">
            <PaginationSection
                totalCount={totalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onArrow={handleArrowClick}
            />
        </div>
    );

    // 메인 UI 렌더링
    return (
        <div className="search-page-wrapper" style={{paddingTop:"80px", paddingBottom:"80px", minHeight: "calc(100vh - 160px)"}}>
            <div className="credit_title_wrap">
                <h3 className="credit_title">'{keyword}'{t('search_result_for_camera_txt')}</h3>
            </div>
            <div className="search_tabs">
                <div className='search_tabs_inner'>
                    <div 
                        className={`tab ${activeTab === 'product' ? 'active' : ''}`}
                        onClick={() => handleTabClick('product')}
                    >
                        {t('product')}
                    </div>
                    <div 
                        className={`tab ${activeTab === 'event' ? 'active' : ''}`}
                        onClick={() => handleTabClick('event')}
                    >
                        {t('event_keyword')}
                    </div>
                </div>
            </div>
            <div className="search-content-wrapper">
                {activeTab === 'product' ? (
                    <div className="product-section-container">
                        {loading ? (
                            <div className="loading-overlay">
                                <div className="loading">로딩 중...</div>
                            </div>
                        ) : products.length > 0 ? (
                            <div className='p0'>
                                <ProductSection
                                    products={products}
                                    showTabs={false}
                                    showMoreButton={false}
                                    beforeContent={<BeforeContent />}
                                    afterContent={<AfterContent />}
                                    useSwiper={false}
                                />
                            </div>
                        ) : (
                            <div className="no_result">
                                <p>{t('no_product_found')}</p>
                                <p>{t('try_another_keyword')}</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="inner" style={{marginTop:'32px'}}>
                        {loading ? (
                            <div className="loading-overlay">
                                <div className="loading">로딩 중...</div>
                            </div>
                        ) : products.length > 0 ? (
                            <>
                                <div className='event_grid'>
                                    <div className='event_con'>
                                        <figure className='event_poster'>
                                            <img src={event_poster} alt="event_poster" loading="lazy"/>
                                        </figure>
                                        <div className='event_desc_box'>
                                            <h3>
                                                학생 고객분들을 위한 35%
                                                할인 이벤트
                                            </h3>
                                            <div className='event_period'>
                                                <p>이벤트 기간:</p>
                                                <span>2023.04.20~2023.05.31</span>
                                            </div>
                                            <p className='event_desc'>
                                                데이페이는 학생을 위하여 최대할인 35%
                                                적용하여 이벤트 합니다.
                                                할인기간동안 모든 장비 추가로 배터리 2개
                                                증정합니다.
                                            </p>
                                            <button 
                                                type='button' 
                                                className='event_detail'
                                                onClick={handleViewMore}
                                            >
                                                자세히 보기
                                            </button>
                                        </div>
                                    </div>
                                    <div className='event_con'>
                                        <figure className='event_poster'>
                                            <img src={event_poster2} alt="event_poster2" loading="lazy"/>
                                        </figure>
                                        <div className='event_desc_box'>
                                            <h3>
                                                학생 고객분들을 위한 35%
                                                할인 이벤트
                                            </h3>
                                            <div className='event_period'>
                                                <p>이벤트 기간:</p>
                                                <span>2023.04.20~2023.05.31</span>
                                            </div>
                                            <p className='event_desc'>
                                                데이페이는 학생을 위하여 최대할인 35%
                                                적용하여 이벤트 합니다.
                                                할인기간동안 모든 장비 추가로 배터리 2개
                                                증정합니다.
                                            </p>
                                            <button 
                                                type='button' 
                                                className='event_detail'
                                                onClick={handleViewMore}
                                            >
                                                자세히 보기
                                            </button>
                                        </div>
                                    </div>
                                    <div className='event_con'>
                                        <figure className='event_poster'>
                                            <img src={event_poster} alt="event_poster" loading="lazy"/>
                                        </figure>
                                        <div className='event_desc_box'>
                                            <h3>
                                                학생 고객분들을 위한 35%
                                                할인 이벤트
                                            </h3>
                                            <div className='event_period'>
                                                <p>이벤트 기간:</p>
                                                <span>2023.04.20~2023.05.31</span>
                                            </div>
                                            <p className='event_desc'>
                                                데이페이는 학생을 위하여 최대할인 35%
                                                적용하여 이벤트 합니다.
                                                할인기간동안 모든 장비 추가로 배터리 2개
                                                증정합니다.
                                            </p>
                                            <button 
                                                type='button' 
                                                className='event_detail'
                                                onClick={handleViewMore}
                                            >
                                                자세히 보기
                                            </button>
                                        </div>
                                    </div>
                                    <div className='event_con'>
                                        <figure className='event_poster'>
                                            <img src={event_poster2} alt="event_poster2" loading="lazy"/>
                                        </figure>
                                        <div className='event_desc_box'>
                                            <h3>
                                                학생 고객분들을 위한 35%
                                                할인 이벤트
                                            </h3>
                                            <div className='event_period'>
                                                <p>이벤트 기간:</p>
                                                <span>2023.04.20~2023.05.31</span>
                                            </div>
                                            <p className='event_desc'>
                                                데이페이는 학생을 위하여 최대할인 35%
                                                적용하여 이벤트 합니다.
                                                할인기간동안 모든 장비 추가로 배터리 2개
                                                증정합니다.
                                            </p>
                                            <button 
                                                type='button' 
                                                className='event_detail'
                                                onClick={handleViewMore}
                                            >
                                                자세히 보기
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="pagination_wrap">
                                    <PaginationSection
                                        totalCount={totalCount}
                                        itemsPerPage={itemsPerPage}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                        onArrow={handleArrowClick}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className="no_result">
                                <p>{t('no_event_found')}</p>
                                <p>{t('try_another_keyword')}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <EventPopup
                isPopup={eventPop}
                setIsPopup={setEventPop}
                />
        </div>
    );
}

export default SearchPage;